import { AffiliateAlanStorage, QUERY_KEYS, AffiliateAlanQuery } from '@monorepo/utils'

const AffiliateQueryStorage = () => {
  if (typeof window === 'undefined') return
  const urlParams = new URLSearchParams(window.location.search)

  const alanQuery = {
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_1]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_1) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_2]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_2) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_3]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_3) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_4]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_4) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_5]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_5) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_6]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_6) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_7]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_7) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_8]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_8) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_9]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_9) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_10]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_10) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_CLICK_ID]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_CLICK_ID) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_PARTNER_ID]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_PARTNER_ID) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_OFFER_ID]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_OFFER_ID) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_CREATIVE_ID]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_CREATIVE_ID) || undefined,
    [QUERY_KEYS.AFFILIATE_ALAN_LANDING_ID]:
      urlParams.get(QUERY_KEYS.AFFILIATE_ALAN_LANDING_ID) || undefined,
  } satisfies Record<keyof AffiliateAlanQuery, string | undefined>

  const dataAlan: Partial<AffiliateAlanQuery> | undefined =
    alanQuery.alan_click_id && alanQuery.partner_id && alanQuery.offer_id && alanQuery.creative_id
      ? alanQuery
      : undefined

  if (dataAlan) AffiliateAlanStorage.set(dataAlan)

  return null
}

export default AffiliateQueryStorage
